import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <div>
      {/* Hero */}
      <section style={{ background: 'var(--hero-gradient)', color: '#fff', padding: '96px 0 80px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '-30%', right: '-10%', width: 480, height: 480, borderRadius: '50%', background: 'radial-gradient(circle, rgba(217,70,239,0.35) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div className="container-narrow" style={{ position: 'relative', textAlign: 'center' }}>
          <span className="chip" style={{ marginBottom: 20 }}>About PerkVora</span>
          <h1 style={{ fontSize: 'clamp(36px, 5vw, 60px)', fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 20 }}>
            Savings shouldn't be a <span className="gradient-text">scavenger hunt.</span>
          </h1>
          <p style={{ fontSize: 18, opacity: 0.86, maxWidth: 620, margin: '0 auto', lineHeight: 1.6 }}>
            We built PerkVora because every other coupon site felt like a trap — expired codes, endless pop-ups, newsletters you never signed up for, and savings that never arrived. So we fixed it.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80, alignItems: 'center' }} className="about-grid">
            <div>
              <span className="eyebrow">Our mission</span>
              <h2 style={{ fontSize: 'clamp(28px, 3.6vw, 42px)', fontWeight: 800, letterSpacing: '-0.025em', margin: '14px 0 20px', lineHeight: 1.15 }}>
                Put <span className="gradient-text">more money</span> back in the pockets of everyday shoppers.
              </h2>
              <p style={{ fontSize: 16, color: '#4A5568', lineHeight: 1.75, marginBottom: 18 }}>
                The average household spends thousands a year on brands that regularly run discounts nobody sees. We close that gap — pulling every verified deal into one clean, honest, fast platform.
              </p>
              <p style={{ fontSize: 16, color: '#4A5568', lineHeight: 1.75 }}>
                No tricks, no data-hoarding, no ten-step redemption flows. Just the perks you deserve, delivered the way they should have been all along.
              </p>
            </div>
            <div style={{ background: 'linear-gradient(135deg, #F3EEFF 0%, #FFE8D6 100%)', borderRadius: 24, padding: 48, textAlign: 'center', minHeight: 320, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 24 }}>
              <div style={{ fontSize: 96 }}>🎯</div>
              <blockquote style={{ fontSize: 18, fontWeight: 600, fontStyle: 'italic', color: '#1A1B4B', maxWidth: 320, lineHeight: 1.5 }}>
                "Perks that value you — not the other way around."
              </blockquote>
            </div>
          </div>
          <style>{`@media(max-width:880px){.about-grid{grid-template-columns:1fr!important;gap:40px!important}}`}</style>
        </div>
      </section>

      {/* Values */}
      <section className="section section-tinted">
        <div className="container">
          <div className="text-center" style={{ marginBottom: 56 }}>
            <span className="eyebrow">What we stand for</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>Four values, zero compromises</h2>
          </div>
          <div className="grid-4">
            <Value icon="🔒" title="Privacy first" body="We don't sell your data. We don't share it. We collect only what we need — and we tell you exactly what that is." />
            <Value icon="✅" title="Verified, always" body="Every deal is tested before going live, and re-tested regularly. Broken codes get pulled automatically." />
            <Value icon="⚡" title="No BS, ever" body="No clickbait 'up to 90% off' when it's really 5%. No hoops to jump through. What you see is what you save." />
            <Value icon="💛" title="For shoppers, by shoppers" body="We built the coupon tool we wished existed. If it wouldn't work for us, it doesn't ship." />
          </div>
        </div>
      </section>

      {/* Numbers */}
      <section className="section" style={{ background: '#fff' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: 48 }}>
            <span className="eyebrow">By the numbers</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>The impact so far</h2>
          </div>
          <div className="grid-4" style={{ gap: 24 }}>
            <BigStat n="$2.4M+" label="Saved by members" />
            <BigStat n="10,000+" label="Verified deals live" />
            <BigStat n="500+" label="Partnered brands" />
            <BigStat n="4.8/5" label="Average rating" />
          </div>
        </div>
      </section>

      {/* Team placeholder */}
      <section className="section section-tinted">
        <div className="container">
          <div className="text-center" style={{ marginBottom: 48 }}>
            <span className="eyebrow">Meet the team</span>
            <h2 className="section-h2" style={{ marginTop: 12 }}>A small crew building big things</h2>
            <p className="section-lead">Engineers, designers, and deal hunters obsessed with making saving money feel effortless.</p>
          </div>
          <div className="grid-4">
            {[
              { name: 'Founder & CEO', role: 'Product & Vision', initial: 'S' },
              { name: 'Head of Engineering', role: 'Platform & Scale', initial: 'A' },
              { name: 'Head of Partnerships', role: 'Brands & Networks', initial: 'M' },
              { name: 'Head of Design', role: 'Experience & Brand', initial: 'K' },
            ].map(m => (
              <div key={m.name} className="card" style={{ textAlign: 'center', padding: 28 }}>
                <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'var(--brand-gradient)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 28, margin: '0 auto 14px', fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}>{m.initial}</div>
                <p style={{ fontWeight: 700, fontSize: 15 }}>{m.name}</p>
                <p style={{ fontSize: 13, color: '#8B94A8', marginTop: 2 }}>{m.role}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 40 }}>
            <Link to="/careers" className="btn btn-outline">We're hiring — see open roles →</Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <h2 style={{ fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, letterSpacing: '-0.025em', marginBottom: 14, lineHeight: 1.1 }}>
              Join the movement.
            </h2>
            <p style={{ fontSize: 16, maxWidth: 520, margin: '0 auto 32px', opacity: 0.95 }}>Thousands of smarter shoppers are already saving with PerkVora. Your turn.</p>
            <Link to="/register" className="btn btn-xl" style={{ background: '#fff', color: '#1A1B4B', fontWeight: 700 }}>
              Create free account →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function Value({ icon, title, body }) {
  return (
    <div className="feature-tile">
      <div className="feature-icon">{icon}</div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-desc">{body}</p>
    </div>
  );
}

function BigStat({ n, label }) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '32px 20px' }}>
      <p style={{ fontSize: 40, fontWeight: 800, letterSpacing: '-0.03em', fontFamily: 'Plus Jakarta Sans, Inter, sans-serif', lineHeight: 1 }} className="gradient-text">{n}</p>
      <p style={{ fontSize: 14, color: '#8B94A8', marginTop: 10, fontWeight: 500 }}>{label}</p>
    </div>
  );
}
